.controls {
  padding: 10px;
  font-weight: 700;
  .logo {
    margin-right: 5px;
  }
}
